"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullInterval = exports.week = exports.day = exports.hour = exports.minute = exports.second = void 0;
exports.union = union;
exports.intersect = intersect;
exports.intersectAll = intersectAll;
exports.subtractIntervals = subtractIntervals;
exports.subtractAllIntervals = subtractAllIntervals;
exports.overlap = overlap;
exports.makeTimeResult = makeTimeResult;
exports.addTimeResults = addTimeResults;
exports.getTotalResults = getTotalResults;
exports.getDailyAverage = getDailyAverage;
exports.getTimeResult = getTimeResult;
exports.getDailyResults = getDailyResults;
exports.getNominalTime = getNominalTime;
exports.applyRounding = applyRounding;
exports.correctRoundedDate = correctRoundedDate;
exports.getStartFinal = getStartFinal;
exports.getEndFinal = getEndFinal;
exports.applyAutoMeals = applyAutoMeals;
exports.applyAutoBreaks = applyAutoBreaks;
exports.getNominalBonus = getNominalBonus;
exports.addTimeBalances = addTimeBalances;
exports.addVacationBalances = addVacationBalances;
exports.addBonusesBalances = addBonusesBalances;
exports.addBalances = addBalances;
exports.makeEmptyTimeBalance = makeEmptyTimeBalance;
exports.makeEmptyVacationBalance = makeEmptyVacationBalance;
exports.makeEmptyBonusesBalance = makeEmptyBonusesBalance;
exports.makeEmptyBalances = makeEmptyBalances;
exports.sumTimeBalances = sumTimeBalances;
exports.sumVacationBalances = sumVacationBalances;
exports.sumBonusesBalances = sumBonusesBalances;
exports.sumBalances = sumBalances;
exports.aggregateDailyResults = aggregateDailyResults;
exports.aggregateTimeBalances = aggregateTimeBalances;
exports.aggregateVacationBalances = aggregateVacationBalances;
exports.aggregateBonusesBalances = aggregateBonusesBalances;
exports.timeBalanceFromDailyResults = timeBalanceFromDailyResults;
exports.vacationBalanceFromDailyResults = vacationBalanceFromDailyResults;
exports.bonusesBalanceFromDailyResults = bonusesBalanceFromDailyResults;
exports.getResultBreakDown = getResultBreakDown;
exports.getAvailableActions = getAvailableActions;
exports.getVacationEntitlement = getVacationEntitlement;
exports.getCommonWorkDays = getCommonWorkDays;
exports.calculateBonusDuration = calculateBonusDuration;
const model_1 = require("./model");
const holidays_1 = require("./holidays");
const util_1 = require("./util");
const payroll_1 = require("./payroll");
const vacation_1 = require("./vacation");
const openapi_1 = require("@pentacode/openapi");
const issues_1 = require("./issues");
const breaks_1 = require("./breaks");
const contract_util_1 = require("./contract.util");
exports.second = 1000;
exports.minute = 60 * exports.second;
exports.hour = 60 * exports.minute;
exports.day = 24 * exports.hour;
exports.week = 7 * exports.day;
// export const weekFactor = 4.35;
exports.nullInterval = [new Date(0), new Date(0)];
function union(...intervals) {
    const itvs = [...intervals].sort(([a], [b]) => Number(a) - Number(b));
    for (let i = 0; i < itvs.length - 1;) {
        if (itvs[i][1] >= itvs[i + 1][1]) {
            // If the current interval ends at or after the next intervals end, remove the next interval
            itvs.splice(i + 1, 1);
        }
        else if (itvs[i][1] >= itvs[i + 1][0]) {
            // if the current interval ends after the next interval starts
            // delete the next interval
            // insert new interval with the start of the current interval and the end of the next interval
            itvs.splice(i, 2, [itvs[i][0], itvs[i + 1][1]]);
        }
        else {
            i++;
        }
    }
    return itvs;
}
// returns the intersection of intervals
function intersect(...intervals) {
    // latest start date
    const start = new Date(Math.max(...intervals.map((i) => Number(i[0]))));
    // earliest end date, but not earlier than start
    const end = new Date(Math.max(Number(start), Math.min(...intervals.map((i) => Number(i[1])))));
    return [start, end];
}
function intersectAll(...all) {
    const [one, two, ...rest] = all;
    if (!one) {
        return [];
    }
    if (!two) {
        return one;
    }
    // create a.length * b.length intersections, then reduce them by union
    const intersects = [];
    for (const a of one) {
        for (const b of two) {
            intersects.push(intersect(a, b));
        }
    }
    const result = union(...intersects);
    // recursive call to intersect the resulting intervals with the remaining Arrays of intervals
    return intersectAll(result, ...rest);
}
function subtractIntervals(a, b) {
    return (
    /*
     * |---|
     *       |---|
     */
    a[0] >= b[1] || a[1] <= b[0]
        ? [a]
        : /*
           *   |---|
           * |-------|
           */
            a[0] >= b[0] && a[1] <= b[1]
                ? []
                : /*
                   * |-------|
                   *   |---|
                   */
                    a[0] < b[0] && a[1] > b[1]
                        ? [
                            [a[0], b[0]],
                            [b[1], a[1]],
                        ]
                        : /*
                           * |-----|
                           *    |-----|
                           */
                            a[0] < b[0] && a[1] <= b[1]
                                ? [[a[0], b[0]]]
                                : /*
                                   *    |-----|
                                   * |-----|
                                   */
                                    a[0] >= b[0] && a[1] > b[1]
                                        ? [[b[1], a[1]]]
                                        : []);
}
function subtractAllIntervals(a, b) {
    if (!b.length) {
        return a;
    }
    const result = [];
    for (const aInt of a) {
        const tempRes = [];
        for (const bInt of b) {
            tempRes.push(subtractIntervals(aInt, bInt));
        }
        result.push(...intersectAll(...tempRes));
    }
    return union(...result);
}
// returns the cumulative overlap between a and each b interval in hours
function overlap(a, b) {
    let result = 0;
    for (const itv of b) {
        result += Math.max(0, Math.min(a[1].getTime(), itv[1].getTime()) - Math.max(a[0].getTime(), itv[0].getTime()));
    }
    return (0, openapi_1.millisecondsToHours)(result);
}
function calculateMealCost(meal) {
    const costs = (meal && (0, openapi_1.multiplyWithRate)(meal.count, meal.value)) || 0;
    return meal
        ? {
            costs,
            ...meal,
        }
        : undefined;
}
function makeTimeResult({ baseDuration = 0, breakPaid = 0, breakTotal = 0, revenue, commission, bonuses = [], days = 0, meals = {}, hourlyRate = 0, ancillaryCostFactor = 0, costCenter, } = {}) {
    var _a, _b, _c;
    const baseWages = (0, openapi_1.multiplyWithRate)(baseDuration, hourlyRate);
    const baseAncillaryCosts = (0, openapi_1.multiplyWithFactor)(baseWages, ancillaryCostFactor);
    const breakWages = (0, openapi_1.multiplyWithRate)(breakPaid, hourlyRate);
    const breakAncillaryCosts = (0, openapi_1.multiplyWithFactor)(breakWages, ancillaryCostFactor);
    const bonusWages = bonuses.reduce((total, bonus) => (0, openapi_1.add)(total, bonus.wages), 0);
    const bonusAncillaryCosts = bonuses.reduce((total, bonus) => (0, openapi_1.add)(total, bonus.ancillaryCosts), 0);
    const commissionWages = (revenue && commission && (0, openapi_1.multiplyWithPercent)(revenue, commission)) || 0;
    const commissionCost = (0, openapi_1.multiplyWithFactor)(commissionWages, ancillaryCostFactor);
    const mealsCost = {
        breakfast: calculateMealCost(meals.breakfast),
        lunch: calculateMealCost(meals.lunch),
        dinner: calculateMealCost(meals.dinner),
    };
    const totalMealsCost = (0, openapi_1.sum)(((_a = mealsCost.breakfast) === null || _a === void 0 ? void 0 : _a.costs) || 0, ((_b = mealsCost.lunch) === null || _b === void 0 ? void 0 : _b.costs) || 0, ((_c = mealsCost.dinner) === null || _c === void 0 ? void 0 : _c.costs) || 0);
    const totalWages = (0, openapi_1.sum)(baseWages, breakWages, bonusWages, commissionWages, commissionWages);
    const totalCosts = (0, openapi_1.sum)(totalWages, baseAncillaryCosts, breakAncillaryCosts, bonusAncillaryCosts, totalMealsCost, commissionCost);
    return {
        meals: mealsCost,
        base: {
            duration: baseDuration,
            hourlyRate,
            wages: baseWages,
            ancillaryCosts: baseAncillaryCosts,
        },
        breaks: {
            duration: breakTotal,
            paidDuration: breakPaid,
            hourlyRate,
            wages: breakWages,
            ancillaryCosts: breakAncillaryCosts,
        },
        commission: commissionWages &&
            revenue &&
            commission &&
            revenue && {
            revenue,
            percent: commission,
            wages: commissionWages,
            ancillaryCosts: commissionCost,
        },
        bonuses,
        days,
        totalWages,
        totalCosts,
        costCenter: costCenter
            ? {
                number: costCenter.number,
                name: costCenter.name,
            }
            : undefined,
    };
}
function addTimeResults(a, b) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const bonuses = a.bonuses.map((b) => ({ ...b }));
    for (const bonus of b.bonuses || []) {
        let existing = bonuses.find((bon) => bon.bonusId === bonus.bonusId && bon.hourlyRate === bonus.hourlyRate && bon.taxFree === bonus.taxFree);
        if (!existing) {
            existing = { ...bonus, duration: 0, wages: 0, ancillaryCosts: 0 };
            bonuses.push(existing);
        }
        existing.duration = (0, openapi_1.add)(existing.duration, bonus.duration);
        existing.wages = (0, openapi_1.add)(existing.wages, bonus.wages);
        existing.ancillaryCosts = (0, openapi_1.add)(existing.ancillaryCosts, bonus.ancillaryCosts);
    }
    return {
        base: {
            duration: (0, openapi_1.add)(a.base.duration, b.base.duration),
            hourlyRate: (0, openapi_1.add)(a.base.hourlyRate, b.base.hourlyRate),
            wages: (0, openapi_1.add)(a.base.wages, b.base.wages),
            ancillaryCosts: (0, openapi_1.add)(a.base.ancillaryCosts, b.base.ancillaryCosts),
        },
        breaks: {
            duration: (0, openapi_1.add)(a.breaks.duration, b.breaks.duration),
            paidDuration: (0, openapi_1.add)(a.breaks.paidDuration, b.breaks.paidDuration),
            hourlyRate: (0, openapi_1.add)(a.breaks.hourlyRate, b.breaks.hourlyRate),
            wages: (0, openapi_1.add)(a.breaks.wages, b.breaks.wages),
            ancillaryCosts: (0, openapi_1.add)(a.breaks.ancillaryCosts, b.breaks.ancillaryCosts),
        },
        bonuses,
        meals: {
            breakfast: a.meals.breakfast || b.meals.breakfast
                ? {
                    count: (0, openapi_1.add)((_a = a.meals.breakfast) === null || _a === void 0 ? void 0 : _a.count, (_b = b.meals.breakfast) === null || _b === void 0 ? void 0 : _b.count),
                    value: (0, openapi_1.multiplyWithFactor)((0, openapi_1.add)((_c = a.meals.breakfast) === null || _c === void 0 ? void 0 : _c.value, (_d = b.meals.breakfast) === null || _d === void 0 ? void 0 : _d.value), 0.5),
                    costs: (0, openapi_1.add)((_e = a.meals.breakfast) === null || _e === void 0 ? void 0 : _e.costs, (_f = b.meals.breakfast) === null || _f === void 0 ? void 0 : _f.costs),
                }
                : undefined,
            lunch: a.meals.lunch || b.meals.lunch
                ? {
                    count: (0, openapi_1.add)((_g = a.meals.lunch) === null || _g === void 0 ? void 0 : _g.count, (_h = b.meals.lunch) === null || _h === void 0 ? void 0 : _h.count),
                    value: (0, openapi_1.multiplyWithFactor)((0, openapi_1.add)((_j = a.meals.lunch) === null || _j === void 0 ? void 0 : _j.value, (_k = b.meals.lunch) === null || _k === void 0 ? void 0 : _k.value), 2),
                    costs: (0, openapi_1.add)((_l = a.meals.lunch) === null || _l === void 0 ? void 0 : _l.costs, (_m = b.meals.lunch) === null || _m === void 0 ? void 0 : _m.costs),
                }
                : undefined,
            dinner: a.meals.dinner || b.meals.dinner
                ? {
                    count: (0, openapi_1.add)((_o = a.meals.dinner) === null || _o === void 0 ? void 0 : _o.count, (_p = b.meals.dinner) === null || _p === void 0 ? void 0 : _p.count),
                    value: (0, openapi_1.multiplyWithFactor)((0, openapi_1.add)((_q = a.meals.dinner) === null || _q === void 0 ? void 0 : _q.value, (_r = b.meals.dinner) === null || _r === void 0 ? void 0 : _r.value), 2),
                    costs: (0, openapi_1.add)((_s = a.meals.dinner) === null || _s === void 0 ? void 0 : _s.costs, (_t = b.meals.dinner) === null || _t === void 0 ? void 0 : _t.costs),
                }
                : undefined,
        },
        days: (0, openapi_1.add)(a.days, b.days),
        totalWages: (0, openapi_1.add)(a.totalWages, b.totalWages),
        totalCosts: (0, openapi_1.add)(a.totalCosts, b.totalCosts),
    };
}
function getTotalResults(results) {
    return results.reduce((total, res) => addTimeResults(total, res), makeTimeResult());
}
function getDailyAverage(results) {
    const total = getTotalResults(results);
    const average = makeTimeResult();
    const days = total.days;
    if (!days) {
        return total;
    }
    const dayFraction = (1 / days);
    average.base.duration = (0, openapi_1.multiplyWithFactor)(total.base.duration, dayFraction);
    average.base.wages = (0, openapi_1.multiplyWithFactor)(total.base.wages, dayFraction);
    average.base.ancillaryCosts = (0, openapi_1.multiplyWithFactor)(total.base.ancillaryCosts, dayFraction);
    average.base.hourlyRate = (0, openapi_1.multiplyWithFactor)(total.base.hourlyRate, dayFraction);
    const bonusesByType = results.reduce((bbt, result) => {
        if (!result) {
            return bbt;
        }
        for (const bonus of result.bonuses || []) {
            if (!bbt.has(bonus.type.id)) {
                bbt.set(bonus.type.id, []);
            }
            bbt.get(bonus.type.id).push(bonus);
        }
        return bbt;
    }, new Map());
    average.bonuses = [...bonusesByType.values()].map((bonuses) => ({
        ...bonuses[0],
        duration: (0, openapi_1.multiplyWithFactor)(bonuses.reduce((total, bonus) => (0, openapi_1.add)(total, bonus.duration), 0), dayFraction),
        wages: (0, openapi_1.multiplyWithFactor)(bonuses.reduce((total, bonus) => (0, openapi_1.add)(total, bonus.wages), 0), dayFraction),
        ancillaryCosts: (0, openapi_1.multiplyWithFactor)(bonuses.reduce((total, bonus) => (0, openapi_1.add)(total, bonus.ancillaryCosts), 0), dayFraction),
        hourlyRate: (0, openapi_1.multiplyWithFactor)(bonuses.reduce((total, bonus) => (0, openapi_1.add)(total, bonus.hourlyRate), 0), dayFraction),
    }));
    average.meals = {
        breakfast: total.meals.breakfast && {
            count: (0, openapi_1.multiplyWithFactor)(total.meals.breakfast.count, dayFraction),
            value: (0, openapi_1.multiplyWithFactor)(total.meals.breakfast.value, dayFraction),
            costs: (0, openapi_1.multiplyWithFactor)(total.meals.breakfast.costs, dayFraction),
        },
        lunch: total.meals.lunch && {
            count: (0, openapi_1.multiplyWithFactor)(total.meals.lunch.count, dayFraction),
            value: (0, openapi_1.multiplyWithFactor)(total.meals.lunch.value, dayFraction),
            costs: (0, openapi_1.multiplyWithFactor)(total.meals.lunch.costs, dayFraction),
        },
        dinner: total.meals.dinner && {
            count: (0, openapi_1.multiplyWithFactor)(total.meals.dinner.count, dayFraction),
            value: (0, openapi_1.multiplyWithFactor)(total.meals.dinner.value, dayFraction),
            costs: (0, openapi_1.multiplyWithFactor)(total.meals.dinner.costs, dayFraction),
        },
    };
    return average;
}
function getBonusResults(company, employee, entry, work) {
    var _a;
    const contract = employee.getContractForDate(entry.date);
    if (!contract) {
        return [];
    }
    const bonuses = [];
    for (const bonus of contract.bonuses) {
        const type = (_a = company.bonusTypes) === null || _a === void 0 ? void 0 : _a.find((t) => t.id === bonus.typeId);
        if (!type || (bonus.positionId && entry.positionId !== bonus.positionId)) {
            continue;
        }
        const mustStartBefore = type.shiftMustStartBefore && (0, util_1.parseTime)(entry.date, type.shiftMustStartBefore);
        if (mustStartBefore && entry.start >= mustStartBefore) {
            continue;
        }
        const matchingDates = type.mode === model_1.BonusTypeMode.Daily
            ? [entry.date]
            : [entry.date, (0, util_1.dateAdd)(entry.date, { days: 1 })].filter((date) => type.matchesDate(date, company.country));
        let intervals = [];
        for (const date of matchingDates) {
            intervals.push(...type.intervals.map(([start, end]) => [(0, util_1.parseTime)(date, start), (0, util_1.parseTime)(date, end)]));
        }
        if (!intervals.length) {
            continue;
        }
        intervals = union(...intervals);
        bonuses.push({
            bonus,
            type,
            intervals,
        });
    }
    for (const bonus of bonuses) {
        for (const override of bonus.type.overrides) {
            const otherBonuses = bonuses.filter((b) => b.type.id === override.objectId);
            for (const otherBonus of otherBonuses) {
                otherBonus.intervals = subtractAllIntervals(otherBonus.intervals, bonus.intervals);
            }
        }
    }
    const workDuration = ((work[1].getTime() - work[0].getTime()) / exports.hour);
    const results = [];
    for (const { bonus, type, intervals } of bonuses) {
        let duration = overlap(work, intervals);
        if ((type.minDuration && duration < type.minDuration) ||
            (type.minDurationPercent && (duration / workDuration) * 100 < type.minDurationPercent)) {
            duration = 0;
        }
        let hourlyRate;
        switch (type.compType) {
            case model_1.BonusCompType.FixedAmount:
                results.push({
                    bonusId: bonus.id,
                    type: {
                        id: type.id,
                        name: type.name,
                        legalType: type.legalType,
                    },
                    taxFree: type.taxFree,
                    ancillaryCosts: 0,
                    duration,
                    wages: bonus.fixedAmount || type.fixedAmountDefault || 0,
                });
                continue;
            case model_1.BonusCompType.FixedHourlyRate:
                hourlyRate = bonus.hourlyRate || type.fixedHourlyRateDefault || 0;
                results.push({
                    bonusId: bonus.id,
                    type: {
                        id: type.id,
                        name: type.name,
                        legalType: type.legalType,
                    },
                    taxFree: type.taxFree,
                    ancillaryCosts: 0,
                    duration,
                    hourlyRate,
                    wages: (0, openapi_1.multiplyWithRate)(duration, hourlyRate),
                });
                continue;
            case model_1.BonusCompType.ModifiedHourlyRate: {
                hourlyRate = (0, payroll_1.getHourlyRate)(company, contract, entry.positionId);
                const percent = bonus.percent || type.defaultPercent || 0;
                const taxFreeUpToRate = type.taxFree ? type.taxFreeUpToRate : 0;
                const taxFreeRate = hourlyRate && (0, openapi_1.min)(hourlyRate, taxFreeUpToRate);
                const taxedRate = hourlyRate && (0, openapi_1.max)(0, (0, openapi_1.subtract)(hourlyRate, taxFreeUpToRate));
                if (taxFreeRate || (!hourlyRate && !!taxFreeUpToRate)) {
                    const wages = (0, openapi_1.multiplyWithPercent)((0, openapi_1.multiplyWithRate)(duration, taxFreeRate), percent);
                    results.push({
                        bonusId: bonus.id,
                        type: {
                            id: type.id,
                            name: type.name,
                            legalType: type.legalType,
                        },
                        taxFree: true,
                        hourlyRate: taxFreeRate,
                        ancillaryCosts: 0,
                        wages,
                        duration,
                        percent,
                    });
                }
                if (taxedRate || (!hourlyRate && !taxFreeUpToRate)) {
                    const wages = (0, openapi_1.multiplyWithPercent)((0, openapi_1.multiplyWithRate)(duration, taxedRate), percent);
                    const ancillaryCosts = (0, openapi_1.multiplyWithFactor)(wages, (0, payroll_1.getAncillaryCostFactor)(contract.employmentType)[0]);
                    results.push({
                        bonusId: bonus.id,
                        type: {
                            id: type.id,
                            name: type.name,
                            legalType: type.legalType,
                        },
                        taxFree: false,
                        hourlyRate: taxedRate,
                        ancillaryCosts,
                        wages,
                        duration,
                        percent,
                    });
                }
                break;
            }
        }
    }
    return results;
}
/** Gets the shift duration for calculating the time result. */
function getShiftDuration(entry, mode) {
    switch (mode) {
        case "planned":
            return entry.planned;
        case "logged":
            return entry.logged;
        case "final":
            return entry.final;
        case "mixed":
            if (entry.final || entry.isPast) {
                return entry.final;
            }
            return entry.planned;
        case "max": {
            return entry.logged && entry.final
                ? [
                    new Date(Math.min(entry.logged[0].getTime(), entry.final[0].getTime())),
                    new Date(Math.max(entry.logged[1].getTime(), entry.final[1].getTime())),
                ]
                : entry.final;
        }
    }
}
function getTimeResult(company, employee, entry, prevAverage, shiftsThatDay = 1, mode = "final") {
    var _a, _b;
    const timeSettings = company.getTimeSettings({ timeEntry: entry }) || new model_1.TimeSettings();
    const { iterativeBreaks } = company.settings;
    const mealValueBreakfast = company.settings.mealValueBreakfast;
    const mealValueLunch = company.settings.mealValueLunch;
    const mealValueDinner = company.settings.mealValueDinner;
    const contract = employee.getContractForDate(entry.date);
    const { breakMode, paidBreaksAuto, paidBreaksManual, breakTiming } = timeSettings;
    const costCenter = company.getCostCenter({ employee, timeEntry: entry, date: entry.date });
    if (!contract) {
        return makeTimeResult();
    }
    const hourlyRate = (0, payroll_1.getHourlyRate)(company, contract, entry.positionId);
    const salary = (0, contract_util_1.getSalaryOrDefault)(entry.positionId, contract.salaries);
    const commission = salary === null || salary === void 0 ? void 0 : salary.commission;
    const ancillaryCostFactor = (0, payroll_1.getAncillaryCostFactor)(contract.employmentType)[0];
    const { absenceMode, absenceHours, fixedWorkDays, hoursPerDay } = contract;
    const year = entry.start.getFullYear();
    const month = entry.start.getMonth();
    const date = entry.start.getDate();
    if (entry.type === model_1.TimeEntryType.Work) {
        const shiftDuration = getShiftDuration(entry, mode);
        if (!shiftDuration || !shiftDuration[0] || !shiftDuration[1]) {
            return makeTimeResult();
        }
        const breakDurations = (0, breaks_1.calculateBreakDurations)(entry, timeSettings, mode, breakMode, // this is already part of timeSettings
        iterativeBreaks, 
        // shift duration is only needed in case of mode = max.
        // It is also always calculated from the entry.
        // We might want to remove this parameter.
        shiftDuration);
        const breakPaid = (0, openapi_1.add)(paidBreaksAuto ? breakDurations.auto : 0, paidBreaksManual ? breakDurations.manual : 0);
        const breakTotal = (0, openapi_1.add)(breakDurations.auto, breakDurations.manual);
        let [start, end] = shiftDuration;
        // subtract break at start of end of shift, depending on setting
        if (breakTiming === model_1.BreakTiming.End) {
            end = new Date(end.getTime() - breakTotal * exports.hour);
        }
        else {
            start = new Date(start.getTime() + breakTotal * exports.hour);
        }
        const work = [start, end];
        const baseDuration = ((end.getTime() - start.getTime()) / exports.hour);
        const bonuses = getBonusResults(company, employee, entry, work);
        return makeTimeResult({
            breakPaid,
            breakTotal,
            baseDuration,
            bonuses,
            meals: {
                breakfast: entry.mealsBreakfast
                    ? {
                        count: entry.mealsBreakfast,
                        value: mealValueBreakfast || 0,
                    }
                    : undefined,
                lunch: entry.mealsLunch
                    ? {
                        count: entry.mealsLunch,
                        value: mealValueLunch || 0,
                    }
                    : undefined,
                dinner: entry.mealsDinner
                    ? {
                        count: entry.mealsDinner,
                        value: mealValueDinner || 0,
                    }
                    : undefined,
            },
            commission,
            revenue: entry.revenue,
            hourlyRate,
            ancillaryCostFactor,
            days: (1 / shiftsThatDay),
            costCenter,
        });
    }
    else if ([
        model_1.TimeEntryType.Vacation,
        model_1.TimeEntryType.Sick,
        model_1.TimeEntryType.ChildSick,
        model_1.TimeEntryType.SickInKUG,
        model_1.TimeEntryType.CompDay,
    ].includes(entry.type)) {
        let baseDuration = prevAverage.base.duration;
        let breakTotal = prevAverage.breaks.duration;
        let breakPaid = prevAverage.breaks.paidDuration;
        if (absenceMode === model_1.AbsenceMode.FixedDays && fixedWorkDays) {
            baseDuration = hoursPerDay ? hoursPerDay[(entry.start.getDay() + 6) % 7] : 0;
            breakTotal = breakPaid = 0;
        }
        else if (absenceMode === model_1.AbsenceMode.Fixed) {
            baseDuration = absenceHours;
            breakTotal = breakPaid = 0;
        }
        // No continued pay in the first 4 weeks of employment
        const firstContract = employee.contracts.sort((a, b) => Number(a.start) - Number(b.start))[0];
        if (!firstContract || Number(new Date(year, month, date)) - Number(firstContract.start) < 4 * exports.week) {
            const result = makeTimeResult();
            result.base.duration = baseDuration;
        }
        const bonuses = [];
        if (entry.type !== model_1.TimeEntryType.CompDay) {
            for (const bonus of contract.bonuses) {
                const bonusType = (_a = company.bonusTypes) === null || _a === void 0 ? void 0 : _a.find((t) => t.id === bonus.typeId);
                if ((bonusType === null || bonusType === void 0 ? void 0 : bonusType.continuedPay) && (bonusType === null || bonusType === void 0 ? void 0 : bonusType.matchesDate(entry.date, company.country))) {
                    const prevBonusAverage = (_b = prevAverage.bonuses) === null || _b === void 0 ? void 0 : _b.find((b) => b.type.id === bonus.typeId);
                    const applicableDuration = (0, openapi_1.min)(baseDuration, (prevBonusAverage === null || prevBonusAverage === void 0 ? void 0 : prevBonusAverage.duration) || 0);
                    const duration = calculateBonusDuration(new Date(entry.date), bonusType.mode, applicableDuration, baseDuration);
                    const wages = (0, openapi_1.multiplyWithPercent)((0, openapi_1.multiplyWithRate)(duration, hourlyRate), bonus.percent);
                    bonuses.push({
                        bonusId: bonus.id,
                        type: {
                            id: bonusType.id,
                            name: bonusType.name,
                            legalType: bonusType.legalType,
                        },
                        duration,
                        taxFree: false,
                        percent: bonus.percent,
                        hourlyRate,
                        wages,
                        ancillaryCosts: (0, openapi_1.multiplyWithFactor)(wages, ancillaryCostFactor),
                    });
                }
            }
        }
        return makeTimeResult({
            baseDuration,
            breakPaid,
            breakTotal,
            bonuses,
            hourlyRate,
            ancillaryCostFactor,
            days: 1,
            costCenter,
        });
    }
    else if (entry.type === model_1.TimeEntryType.HourAdjustment) {
        return makeTimeResult({
            baseDuration: entry.hours ? entry.hours : 0,
            hourlyRate: entry.paid ? hourlyRate : 0,
        });
    }
    else if (entry.type === model_1.TimeEntryType.VacationAdjustment) {
        const days = (entry.days || 0);
        let baseDuration = prevAverage.base.duration;
        let breakTotal = prevAverage.breaks.duration;
        let breakPaid = prevAverage.breaks.paidDuration;
        if (absenceMode === model_1.AbsenceMode.FixedDays && fixedWorkDays) {
            baseDuration = hoursPerDay ? hoursPerDay[(entry.start.getDay() + 6) % 7] : 0;
            breakTotal = breakPaid = 0;
        }
        else if (absenceMode === model_1.AbsenceMode.Fixed) {
            baseDuration = absenceHours;
            breakTotal = breakPaid = 0;
        }
        return makeTimeResult({
            baseDuration: (0, openapi_1.multiplyWithFactor)(baseDuration, days),
            hourlyRate: entry.paid ? hourlyRate : 0,
            breakTotal: (0, openapi_1.multiplyWithFactor)(breakTotal, days),
            breakPaid: (0, openapi_1.multiplyWithFactor)(breakPaid, days),
            days: entry.days || 0,
        });
    }
    else {
        return makeTimeResult();
    }
}
function getDailyResults(company, employee, entries, { from, to }, previousResults) {
    // !!! This Function also potentially mutates the input TimeEntries and updates their results if not set
    var _a;
    const dailyResults = [];
    let date = from;
    let lastResult = previousResults[previousResults.length - 1];
    // time results are not used in this function, so we can call it before results are updated
    const issues = (0, issues_1.getShiftIssues)(employee, company, entries, { from, to });
    while (date < to) {
        const dayEntries = entries.filter((e) => e.date === date);
        const workEntries = dayEntries.filter((e) => e.type === model_1.TimeEntryType.Work);
        const reset = dayEntries.find((e) => e.type === model_1.TimeEntryType.ResetLedgers);
        const allResults = [...previousResults, ...dailyResults];
        const lastDayOfPreviousMonth = (0, util_1.dateAdd)((0, util_1.getRange)(date, "month").from, { days: -1 });
        const averagesResult = allResults.find((res) => res.date === lastDayOfPreviousMonth);
        const contract = employee.getContractForDate(date);
        const results = {
            work: makeTimeResult(),
            workPlanned: makeTimeResult(),
            absences: makeTimeResult(),
            adjustments: makeTimeResult(),
            total: makeTimeResult(),
        };
        let vacationDays = 0;
        let vacationAdjustments = 0;
        if (contract) {
            for (const entry of dayEntries) {
                if (!entry.result) {
                    entry.result = getTimeResult(company, employee, entry, (averagesResult === null || averagesResult === void 0 ? void 0 : averagesResult.averages["13weeks"]) || makeTimeResult(), workEntries.filter((e) => e.startFinal && e.endFinal).length, "final");
                }
                if (!entry.resultPlanned) {
                    entry.resultPlanned = getTimeResult(company, employee, entry, (averagesResult === null || averagesResult === void 0 ? void 0 : averagesResult.averages["13weeks"]) || makeTimeResult(), workEntries.length, "planned");
                }
                if (!entry.resultMaxTotalCosts) {
                    const { totalCosts } = getTimeResult(company, employee, entry, (averagesResult === null || averagesResult === void 0 ? void 0 : averagesResult.averages["13weeks"]) || makeTimeResult(), workEntries.length, "max");
                    entry.resultMaxTotalCosts = totalCosts;
                }
            }
            vacationDays = dayEntries
                .filter((e) => e.type === model_1.TimeEntryType.Vacation)
                .reduce((total, e) => { var _a; return (0, openapi_1.add)(total, (_a = e.days) !== null && _a !== void 0 ? _a : 1); }, 0);
            vacationAdjustments = dayEntries
                .filter((e) => e.type === model_1.TimeEntryType.VacationAdjustment)
                .reduce((total, e) => { var _a; return (0, openapi_1.add)(total, (_a = e.days) !== null && _a !== void 0 ? _a : 1); }, 0);
            results.work = getTotalResults(workEntries.map((e) => e.result).filter(Boolean));
            results.workPlanned = getTotalResults(workEntries.map((e) => e.resultPlanned).filter(Boolean));
            results.absences = getTotalResults(dayEntries
                .filter((e) => [
                model_1.TimeEntryType.Sick,
                model_1.TimeEntryType.Vacation,
                model_1.TimeEntryType.Sick,
                model_1.TimeEntryType.SickInKUG,
                model_1.TimeEntryType.ChildSick,
                model_1.TimeEntryType.CompDay,
            ].includes(e.type))
                .map((e) => e.result)
                .filter(Boolean));
            results.adjustments = getTotalResults(dayEntries
                .filter((e) => [model_1.TimeEntryType.HourAdjustment].includes(e.type))
                .map((e) => e.result)
                .filter(Boolean));
            results.total = getTotalResults([results.work, results.absences, results.adjustments]);
        }
        const getTimeBalance = (planned = false) => {
            var _a, _b, _c, _d;
            const carry = (planned ? (_a = lastResult === null || lastResult === void 0 ? void 0 : lastResult.timeBalancePlanned) === null || _a === void 0 ? void 0 : _a.balance : lastResult === null || lastResult === void 0 ? void 0 : lastResult.timeBalance.balance) || 0;
            const nominal = getNominalTime(company, employee, { from: date, to: (0, util_1.dateAdd)(date, { days: 1 }) });
            const work = planned ? ((_b = results.workPlanned) === null || _b === void 0 ? void 0 : _b.base.duration) || 0 : results.work.base.duration;
            const absences = results.absences.base.duration;
            const adjustments = results.adjustments.base.duration;
            const actual = (0, openapi_1.sum)(work, absences, adjustments);
            const difference = (0, openapi_1.subtract)(actual, nominal);
            const base = (_c = reset === null || reset === void 0 ? void 0 : reset.hours) !== null && _c !== void 0 ? _c : carry;
            const balance = (0, openapi_1.add)(base, difference);
            return {
                reset: (_d = reset === null || reset === void 0 ? void 0 : reset.hours) !== null && _d !== void 0 ? _d : undefined,
                nominal,
                work,
                adjustments,
                absences,
                actual,
                difference,
                carry,
                balance,
            };
        };
        const getVacationBalance = (timeBalance) => {
            var _a, _b;
            const contract = employee.getContractForDate(date);
            const carry = (lastResult === null || lastResult === void 0 ? void 0 : lastResult.vacationBalance.balance) || 0;
            const base = (_a = reset === null || reset === void 0 ? void 0 : reset.days) !== null && _a !== void 0 ? _a : carry;
            const vacationFactor = ((contract === null || contract === void 0 ? void 0 : contract.vacationIncrement) === model_1.VacationIncrement.Hourly && timeBalance.nominal
                ? timeBalance.actual / timeBalance.nominal
                : 1);
            let nominal = (0, vacation_1.calcVacationEntitlement)(employee, { from: date, to: (0, util_1.dateAdd)(date, { days: 1 }) }, company.settings);
            nominal = (0, openapi_1.multiplyWithFactor)(nominal, vacationFactor);
            const actual = (0, openapi_1.add)(vacationDays, vacationAdjustments);
            const difference = (0, openapi_1.subtract)(nominal, actual);
            const balance = (0, openapi_1.add)(base, difference);
            return {
                reset: (_b = reset === null || reset === void 0 ? void 0 : reset.days) !== null && _b !== void 0 ? _b : undefined,
                nominal,
                taken: vacationDays,
                adjustments: vacationAdjustments,
                actual,
                difference,
                carry,
                balance,
            };
        };
        const getBonusesBalance = () => {
            var _a, _b;
            const taxed = results.total.bonuses
                .filter((b) => !b.taxFree)
                .reduce((total, b) => (0, openapi_1.add)(total, b.wages), 0);
            const untaxed = results.total.bonuses
                .filter((b) => b.taxFree)
                .reduce((total, b) => (0, openapi_1.add)(total, b.wages), 0);
            const actual = company.settings.includeTaxedBonusesInBalance ? (0, openapi_1.add)(taxed, untaxed) : untaxed;
            if (!(contract === null || contract === void 0 ? void 0 : contract.enableSFNLedger)) {
                return {
                    taxed,
                    untaxed,
                    actual,
                };
            }
            const nominal = getNominalBonus(employee, { from: date, to: (0, util_1.dateAdd)(date, { days: 1 }) });
            const difference = (0, openapi_1.subtract)(actual, nominal);
            // Bonuses balance is always reset with the beginning of a new year
            const carry = date.endsWith("01-01") ? 0 : (lastResult === null || lastResult === void 0 ? void 0 : lastResult.bonusesBalance.balance) || 0;
            const base = (_a = reset === null || reset === void 0 ? void 0 : reset.resetBonus) !== null && _a !== void 0 ? _a : carry;
            const balance = (0, openapi_1.add)(base, difference);
            return {
                reset: (_b = reset === null || reset === void 0 ? void 0 : reset.resetBonus) !== null && _b !== void 0 ? _b : undefined,
                nominal,
                taxed,
                untaxed,
                actual,
                difference,
                carry,
                balance,
            };
        };
        let _13weekAverage = (lastResult === null || lastResult === void 0 ? void 0 : lastResult.averages["13weeks"]) || makeTimeResult();
        // For historical reasons, we calculate a new 13 week average for each month
        // and use the same average for the whole month instead of calculating a new
        // (more accurate) value for each day
        if ((0, util_1.dateAdd)(date, { days: 1 }).endsWith("-01")) {
            // The previous daily results act as the basis for calcuating the average
            const allResults = [...previousResults, ...dailyResults];
            // We start calculating from the last work day
            const lastWorkDate = results.work.base.duration
                ? date
                : ((_a = [...allResults].reverse().find((r) => r.results.work.days)) === null || _a === void 0 ? void 0 : _a.date) || date;
            const to = (0, util_1.dateAdd)(lastWorkDate, { days: 1 });
            // Averages are calculated from the last 13 weeks
            // (calculating backwards from the last work day)
            const from = (0, util_1.dateAdd)(to, { weeks: -13 });
            const averagesInput = allResults.filter((r) => r.date >= from && r.date < to);
            // Only work results are considered
            const workResults = [...averagesInput.map((e) => e.results.work), results.work];
            _13weekAverage = getDailyAverage(workResults);
        }
        const timeBalance = getTimeBalance();
        const result = new model_1.DailyResults({
            employeeId: employee.id,
            date,
            averages: {
                "13weeks": _13weekAverage,
            },
            results,
            timeBalance,
            timeBalancePlanned: getTimeBalance(true),
            vacationBalance: getVacationBalance(timeBalance),
            bonusesBalance: getBonusesBalance(),
            issues: issues.filter((i) => i.date === date),
        });
        // If this is the last date of the payroll period, check for payroll issues
        if (new Date((0, util_1.dateAdd)(date, { days: 1 })).getDate() === company.settings.startPayrollPeriod) {
            result.issues.push(...(0, issues_1.getPayrollIssues)(company, employee, entries, (0, payroll_1.getPayrollPeriod)(date, company.settings.startPayrollPeriod)));
        }
        dailyResults.push(result);
        lastResult = result;
        date = (0, util_1.dateAdd)(date, { days: 1 });
    }
    return dailyResults;
}
function getNominalTime(company, emp, { from, to }) {
    var _a;
    const startLedgers = company.settings.startLedgers;
    const contracts = emp.contracts.filter((c) => c.start <= to && (!c.end || c.end > from));
    const defaultPosition = emp.positions[0];
    const venue = (defaultPosition &&
        company.venues.find((v) => v.departments.some((d) => d.positions.some((p) => p.id === defaultPosition.id)))) ||
        company.venues[0];
    const holidays = (venue === null || venue === void 0 ? void 0 : venue.enabledHolidays) || undefined;
    const weekFactor = company.settings.weekFactor || 4.35;
    let total = 0;
    for (const contract of contracts) {
        const mode = contract.nominalHoursMode;
        let start = from >= contract.start ? from : contract.start;
        if (startLedgers && startLedgers > start) {
            start = startLedgers;
        }
        const end = !contract.end || contract.end > to ? to : contract.end;
        if (start > end) {
            start = end;
        }
        switch (mode) {
            case model_1.NominalHoursMode.WeekFactor:
                while (start < end) {
                    const { from, to } = (0, util_1.getRange)(start, "month");
                    const subEnd = to < end ? to : end;
                    const fraction = ((0, util_1.dateSub)(start, subEnd) / (0, util_1.dateSub)(from, to));
                    total = (0, openapi_1.add)(total, (0, openapi_1.multiplyWithFactor)((0, openapi_1.multiplyWithFactor)(contract.hoursPerWeek, weekFactor), fraction));
                    start = subEnd;
                }
                break;
            case model_1.NominalHoursMode.Exact:
            case model_1.NominalHoursMode.ExactWithoutHolidays: {
                let days = (0, util_1.dateSub)(start, end);
                if (mode === model_1.NominalHoursMode.ExactWithoutHolidays) {
                    const holidaysInRange = (0, holidays_1.getHolidaysInRange)(start, end, { holidays, country: company.country });
                    days -= holidaysInRange.length;
                }
                const weeks = (days / 7);
                total = (0, openapi_1.add)(total, (0, openapi_1.multiplyWithFactor)(contract.hoursPerWeek, weeks));
                break;
            }
            case model_1.NominalHoursMode.FixedDays:
            case model_1.NominalHoursMode.FixedDaysWithoutHolidays: {
                let day = start;
                while (day < end) {
                    const date = (0, util_1.parseDateString)(day);
                    const hours = ((_a = contract.hoursPerDay) === null || _a === void 0 ? void 0 : _a[(date.getDay() + 6) % 7]) || 0;
                    if (mode === model_1.NominalHoursMode.FixedDays ||
                        !(0, holidays_1.isHoliday)(date.getFullYear(), date.getMonth(), date.getDate(), {
                            holidays,
                            country: company.country,
                        })) {
                        total = (0, openapi_1.add)(total, hours);
                    }
                    day = (0, util_1.dateAdd)(day, { days: 1 });
                }
                break;
            }
        }
    }
    return total;
}
/**
 * Mutates the given date by applying rounding to the minutes.
 *
 * If `rounding` is positive, the date is rounded up, if negative, it is rounded down.
 *
 * The date is also rounded down to the full minute.
 *
 * @param date The date to apply rounding to
 * @param rounding The rounding to apply in Minutes
 */
function applyRounding(date, rounding) {
    if (rounding) {
        const minutes = date.getMinutes();
        // Minutes subtracted to round down
        const deltaRoundDown = minutes % rounding;
        // If rounding is positive, rounding is added to round up
        const deltaRoundUp = Math.max(0, rounding);
        // apply roundings
        date.setMinutes(minutes - deltaRoundDown + deltaRoundUp);
    }
    // Round to full minute
    date.setSeconds(0);
    date.setMilliseconds(0);
}
/**
 * Corrects to `plannedDate` if `date` was logged before `plannedDate` but rounded up beyond it
 * or if it was logged after plannedDate, but rounded down to earlier than it
 * @param date The date to be corrected
 * @param loggedTime The date `date` was logged
 * @param plannedDate The date that `date` should be corrected to
 * @returns Copy of `plannedDate` if correction is neccessary, otherwise `date`
 */
function correctRoundedDate(date, loggedTime, plannedDate) {
    if (!plannedDate)
        return date;
    if ((loggedTime <= plannedDate && date > plannedDate) || (loggedTime >= plannedDate && date < plannedDate)) {
        return new Date(plannedDate);
    }
    return date;
}
function getStartFinal(timeEntry, loggedTime, useActualTimeAtShiftStart, shiftStartRounding) {
    // If logged time is earlier than planned and useActualTimeAtShiftStart setting
    // is not set, use planned time instead
    let startFinal = timeEntry.startPlanned && loggedTime < timeEntry.startPlanned && !useActualTimeAtShiftStart
        ? new Date(timeEntry.startPlanned)
        : new Date(loggedTime);
    applyRounding(startFinal, shiftStartRounding);
    startFinal = correctRoundedDate(startFinal, loggedTime, timeEntry.startPlanned);
    return startFinal;
}
function getEndFinal(timeEntry, loggedTime, useActualTimeAtShiftEnd, shiftEndRounding) {
    // If logged time is later than planned and useActualTimeAtShiftEnd setting
    // is not set, use planned time instead
    let endFinal = timeEntry.endPlanned && loggedTime > timeEntry.endPlanned && !useActualTimeAtShiftEnd
        ? new Date(timeEntry.endPlanned)
        : new Date(loggedTime);
    applyRounding(endFinal, shiftEndRounding);
    endFinal = correctRoundedDate(endFinal, loggedTime, timeEntry.endPlanned);
    // Make sure end time is not earlier than start time
    if (timeEntry.startFinal && endFinal < timeEntry.startFinal) {
        endFinal = timeEntry.startFinal;
    }
    return endFinal;
}
function applyAutoMeals(company, timeEntry, { breakfast, lunch, dinner }) {
    const timeSettings = company.getTimeSettings({ timeEntry });
    if (timeSettings.mealsMode !== model_1.MealsMode.Auto ||
        !timeEntry.final ||
        timeEntry.durationFinal < timeSettings.mealsMinDuration) {
        return;
    }
    const breakfastInterval = timeSettings.mealEnabledBreakfast &&
        timeSettings.mealStartBreakfast &&
        timeSettings.mealEndBreakfast &&
        (0, util_1.parseTimes)(timeEntry.date, timeSettings.mealStartBreakfast, timeSettings.mealEndBreakfast);
    const lunchInterval = timeSettings.mealEnabledLunch &&
        timeSettings.mealStartLunch &&
        timeSettings.mealEndLunch &&
        (0, util_1.parseTimes)(timeEntry.date, timeSettings.mealStartLunch, timeSettings.mealEndLunch);
    const dinnerInterval = timeSettings.mealEnabledDinner &&
        timeSettings.mealStartDinner &&
        timeSettings.mealEndDinner &&
        (0, util_1.parseTimes)(timeEntry.date, timeSettings.mealStartDinner, timeSettings.mealEndDinner);
    if (breakfastInterval && breakfast && overlap(timeEntry.final, [breakfastInterval])) {
        timeEntry.mealsBreakfast = 1;
    }
    if (dinnerInterval && dinner && overlap(timeEntry.final, [dinnerInterval])) {
        timeEntry.mealsDinner = 1;
    }
    if (lunchInterval && lunch && overlap(timeEntry.final, [lunchInterval])) {
        timeEntry.mealsLunch = 1;
    }
}
function applyAutoBreaks(entry, breakMode, autoBreaks) {
    var _a;
    const breakAuto = [model_1.BreakMode.Planned, model_1.BreakMode.PlannedPlusManual, model_1.BreakMode.PlannedOrManual].includes(breakMode)
        ? entry.breakPlanned || 0
        : (0, breaks_1.getAutomaticBreak)(entry.durationFinal, { autoBreaks, breakMode });
    const prevBreak = entry.break || 0;
    const breakLogged = entry.breakLogged || 0;
    if (entry.break === null || breakAuto !== entry.breakAuto) {
        const prevBreakAuto = (_a = entry.breakAuto) !== null && _a !== void 0 ? _a : breakAuto;
        entry.breakAuto = breakAuto;
        const brk = [model_1.BreakMode.AutoOrManual, model_1.BreakMode.PlannedOrManual].includes(breakMode)
            ? (0, openapi_1.max)(breakAuto, breakLogged)
            : (0, openapi_1.add)(breakAuto, breakLogged);
        const prevBreakAutoWithManual = [model_1.BreakMode.AutoOrManual, model_1.BreakMode.PlannedOrManual].includes(breakMode)
            ? (0, openapi_1.max)(prevBreakAuto, breakLogged)
            : (0, openapi_1.add)(prevBreakAuto, breakLogged);
        // If break is null or hasn't been edited after the fact, update value
        if (entry.break === null || prevBreak - prevBreakAutoWithManual * 60 < 1) {
            entry.break = brk;
        }
    }
}
function getNominalBonus(emp, { from, to }) {
    const contracts = emp.contracts.filter((c) => c.start <= to && (!c.end || c.end > from));
    let total = 0;
    for (const contract of contracts) {
        let start = from >= contract.start ? from : contract.start;
        const end = !contract.end || contract.end > to ? to : contract.end;
        if (start > end) {
            start = end;
        }
        while (start < end) {
            const { from, to } = (0, util_1.getRange)(start, "month");
            const subEnd = to < end ? to : end;
            const fraction = ((0, util_1.dateSub)(start, subEnd) / (0, util_1.dateSub)(from, to));
            total = (0, openapi_1.add)(total, (0, openapi_1.multiplyWithFactor)(contract.sfnAdvance, fraction));
            start = subEnd;
        }
    }
    return total;
}
function roundTimeBalance(balance) {
    var _a, _b;
    return {
        ...balance,
        work: (0, openapi_1.round)(balance.work, 2),
        absences: (0, openapi_1.round)(balance.absences, 2),
        adjustments: (0, openapi_1.round)(balance.adjustments, 2),
        actual: (0, openapi_1.round)(balance.actual, 2),
        nominal: (0, openapi_1.round)(balance.nominal, 2),
        difference: (0, openapi_1.round)(balance.difference, 2),
        reset: typeof balance.reset === "number" ? (0, openapi_1.round)(balance.reset, 2) : undefined,
        carry: (0, openapi_1.round)((_a = balance.carry) !== null && _a !== void 0 ? _a : 0, 2),
        balance: (0, openapi_1.round)((_b = balance.balance) !== null && _b !== void 0 ? _b : 0, 2),
    };
}
function roundVacationBalance(balance) {
    return {
        ...balance,
        taken: (0, openapi_1.round)(balance.taken, 2),
        adjustments: (0, openapi_1.round)(balance.adjustments, 2),
        actual: (0, openapi_1.round)(balance.actual, 2),
        nominal: (0, openapi_1.round)(balance.nominal, 2),
        difference: (0, openapi_1.round)(balance.difference, 2),
        reset: typeof balance.reset === "number" ? (0, openapi_1.round)(balance.reset, 2) : undefined,
        carry: (0, openapi_1.round)(balance.carry || 0, 2),
        balance: (0, openapi_1.round)(balance.balance || 0, 2),
    };
}
function roundBonusesBalance(balance) {
    return {
        ...balance,
        taxed: (0, openapi_1.round)(balance.taxed, 2),
        untaxed: (0, openapi_1.round)(balance.untaxed, 2),
        actual: (0, openapi_1.round)(balance.actual, 2),
        nominal: typeof balance.nominal !== "undefined" ? (0, openapi_1.round)(balance.nominal, 2) : undefined,
        difference: typeof balance.difference !== "undefined" ? (0, openapi_1.round)(balance.difference, 2) : undefined,
        reset: typeof balance.reset === "number" ? (0, openapi_1.round)(balance.reset, 2) : undefined,
        carry: typeof balance.carry !== "undefined" ? (0, openapi_1.round)(balance.carry, 2) : undefined,
        balance: typeof balance.balance !== "undefined" ? (0, openapi_1.round)(balance.balance, 2) : undefined,
    };
}
/** @deprecated Use `roundTimeBalance`, `roundVacationBalance`, `roundBonusesBalance` instead */
function roundBalances(balances) {
    return {
        ...balances,
        time: roundTimeBalance(balances.time),
        vacation: roundVacationBalance(balances.vacation),
        bonuses: roundBonusesBalance(balances.bonuses),
    };
}
function addTimeBalances(balanceA, balanceB) {
    return {
        ...balanceA,
        carry: (0, openapi_1.add)(balanceA.carry, balanceB.carry),
        actual: (0, openapi_1.add)(balanceA.actual, balanceB.actual),
        nominal: (0, openapi_1.add)(balanceA.nominal, balanceB.nominal),
        difference: (0, openapi_1.add)(balanceA.difference, balanceB.difference),
        work: (0, openapi_1.add)(balanceA.work, balanceB.work),
        absences: (0, openapi_1.add)(balanceA.absences, balanceB.absences),
        adjustments: (0, openapi_1.add)(balanceA.adjustments, balanceB.adjustments),
        balance: (0, openapi_1.add)(balanceA.balance, balanceB.balance),
    };
}
function addVacationBalances(balanceA, balanceB) {
    return {
        ...balanceA,
        carry: (0, openapi_1.add)(balanceA.carry, balanceB.carry),
        actual: (0, openapi_1.add)(balanceA.actual, balanceB.actual),
        nominal: (0, openapi_1.add)(balanceA.nominal, balanceB.nominal),
        difference: (0, openapi_1.add)(balanceA.difference, balanceB.difference),
        taken: (0, openapi_1.add)(balanceA.taken, balanceB.taken),
        adjustments: (0, openapi_1.add)(balanceA.adjustments, balanceB.adjustments),
        balance: (0, openapi_1.add)(balanceA.balance, balanceB.balance),
    };
}
function addBonusesBalances(balanceA, balanceB) {
    var _a, _b, _c, _d;
    return {
        ...balanceA,
        carry: typeof balanceA.carry === "number" && typeof balanceB.carry === "number"
            ? (0, openapi_1.add)(balanceA.carry, balanceB.carry)
            : ((_a = balanceA.carry) !== null && _a !== void 0 ? _a : balanceB.carry),
        actual: (0, openapi_1.add)(balanceA.actual, balanceB.actual),
        nominal: typeof balanceA.nominal === "number" && typeof balanceB.nominal === "number"
            ? (0, openapi_1.add)(balanceA.nominal, balanceB.nominal)
            : ((_b = balanceA.nominal) !== null && _b !== void 0 ? _b : balanceB.nominal),
        difference: typeof balanceA.difference === "number" && typeof balanceB.difference === "number"
            ? (0, openapi_1.add)(balanceA.difference, balanceB.difference)
            : ((_c = balanceA.difference) !== null && _c !== void 0 ? _c : balanceB.difference),
        taxed: (0, openapi_1.add)(balanceA.taxed, balanceB.taxed),
        untaxed: (0, openapi_1.add)(balanceA.untaxed, balanceB.untaxed),
        balance: typeof balanceA.balance === "number" && typeof balanceB.balance === "number"
            ? (0, openapi_1.add)(balanceA.balance, balanceB.balance)
            : ((_d = balanceA.balance) !== null && _d !== void 0 ? _d : balanceB.balance),
    };
}
/** @deprecated Use `addTimeBalance`, `addVacationBalance`, `addBonusesBalance` instead */
function addBalances(balanceA, balanceB) {
    return {
        ...balanceA,
        time: addTimeBalances(balanceA.time, balanceB.time),
        vacation: addVacationBalances(balanceA.vacation, balanceB.vacation),
        bonuses: addBonusesBalances(balanceA.bonuses, balanceB.bonuses),
    };
}
function makeEmptyTimeBalance({ employeeId, from, to }) {
    return {
        employeeId,
        from,
        to,
        carry: 0,
        actual: 0,
        nominal: 0,
        difference: 0,
        work: 0,
        absences: 0,
        adjustments: 0,
        balance: 0,
    };
}
function makeEmptyVacationBalance({ employeeId, from, to, }) {
    return {
        employeeId,
        from,
        to,
        carry: 0,
        actual: 0,
        nominal: 0,
        difference: 0,
        taken: 0,
        adjustments: 0,
        balance: 0,
    };
}
function makeEmptyBonusesBalance({ employeeId, from, to }) {
    return {
        employeeId,
        from,
        to,
        actual: 0,
        taxed: 0,
        untaxed: 0,
    };
}
/** @deprecated Use `makeEmptyTimeBalance`, `makeEmptyVacationBalance`, `makeEmptyBonusesBalance` instead */
function makeEmptyBalances({ employeeId, from, to }) {
    return {
        employeeId,
        from,
        to,
        time: makeEmptyTimeBalance({ employeeId, from, to }),
        vacation: makeEmptyVacationBalance({ employeeId, from, to }),
        bonuses: makeEmptyBonusesBalance({ employeeId, from, to }),
    };
}
function sumTimeBalances(balances) {
    if (!balances.length) {
        return makeEmptyTimeBalance({
            employeeId: 0,
            from: "1970-01-01",
            to: "1970-01-01",
        });
    }
    return balances.reduce((total, each) => addTimeBalances(total, each), makeEmptyTimeBalance(balances[0]));
}
function sumVacationBalances(balances) {
    if (!balances.length) {
        return makeEmptyVacationBalance({
            employeeId: 0,
            from: "1970-01-01",
            to: "1970-01-01",
        });
    }
    return balances.reduce((total, each) => addVacationBalances(total, each), makeEmptyVacationBalance(balances[0]));
}
function sumBonusesBalances(balances) {
    if (!balances.length) {
        return makeEmptyBonusesBalance({
            employeeId: 0,
            from: "1970-01-01",
            to: "1970-01-01",
        });
    }
    return balances.reduce((total, each) => addBonusesBalances(total, each), makeEmptyBonusesBalance(balances[0]));
}
/** @deprecated Use `sumTimeBalance`, `sumVacationBalance`, `sumBonusesBalance` instead */
function sumBalances(balances) {
    if (!balances.length) {
        return makeEmptyBalances({ employeeId: 0, from: "1970-01-01", to: "1970-01-01" });
    }
    return balances.reduce((total, each) => addBalances(total, each), makeEmptyBalances(balances[0]));
}
/** @deprecated Use `timeBalanceFromDailyResults`, `vacationBalanceFromDailyResults`, `bonusesBalanceFromDailyResults` instead */
function aggregateDailyResults(results, roundValues = true, projected = false) {
    const firstResult = results[0];
    const today = (0, util_1.toDateString)(new Date());
    const firstTimeBalance = (projected && (firstResult === null || firstResult === void 0 ? void 0 : firstResult.date) >= today && (firstResult === null || firstResult === void 0 ? void 0 : firstResult.timeBalancePlanned)) || (firstResult === null || firstResult === void 0 ? void 0 : firstResult.timeBalance);
    const balances = results.reduce((total, result) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const timeBalance = (projected && result.date >= today && result.timeBalancePlanned) || result.timeBalance;
        return {
            ...total,
            time: {
                ...total.time,
                carry: (_a = total.time.carry) !== null && _a !== void 0 ? _a : timeBalance.carry,
                actual: (0, openapi_1.add)(total.time.actual, timeBalance.actual),
                nominal: (0, openapi_1.add)(total.time.nominal, timeBalance.nominal),
                difference: (0, openapi_1.add)(total.time.difference, timeBalance.difference),
                work: (0, openapi_1.add)(total.time.work, timeBalance.work),
                absences: (0, openapi_1.add)(total.time.absences, timeBalance.absences),
                adjustments: (0, openapi_1.add)(total.time.adjustments, timeBalance.adjustments),
                balance: (_b = timeBalance.balance) !== null && _b !== void 0 ? _b : total.time.balance,
            },
            vacation: {
                ...total.vacation,
                carry: (_c = total.vacation.carry) !== null && _c !== void 0 ? _c : result.vacationBalance.carry,
                taken: (0, openapi_1.add)(total.vacation.taken, result.vacationBalance.taken),
                adjustments: (0, openapi_1.add)(total.vacation.adjustments, result.vacationBalance.adjustments),
                actual: (0, openapi_1.add)(total.vacation.actual, result.vacationBalance.actual),
                nominal: (0, openapi_1.add)(total.vacation.nominal, result.vacationBalance.nominal),
                difference: (0, openapi_1.add)(total.vacation.difference, result.vacationBalance.difference),
                balance: (_d = result.vacationBalance.balance) !== null && _d !== void 0 ? _d : total.vacation.balance,
            },
            bonuses: {
                ...total.bonuses,
                carry: (_e = total.bonuses.carry) !== null && _e !== void 0 ? _e : result.bonusesBalance.carry,
                taxed: (0, openapi_1.add)(total.bonuses.taxed, result.bonusesBalance.taxed),
                untaxed: (0, openapi_1.add)(total.bonuses.untaxed, result.bonusesBalance.untaxed),
                actual: (0, openapi_1.add)(total.bonuses.actual, result.bonusesBalance.actual),
                nominal: typeof total.bonuses.nominal === "number" && typeof result.bonusesBalance.nominal === "number"
                    ? (0, openapi_1.add)(total.bonuses.nominal, result.bonusesBalance.nominal)
                    : ((_f = total.bonuses.nominal) !== null && _f !== void 0 ? _f : result.bonusesBalance.nominal),
                difference: typeof total.bonuses.difference === "number" &&
                    typeof result.bonusesBalance.difference === "number"
                    ? (0, openapi_1.add)(total.bonuses.difference, result.bonusesBalance.difference)
                    : ((_g = total.bonuses.difference) !== null && _g !== void 0 ? _g : result.bonusesBalance.difference),
                balance: (_h = result.bonusesBalance.balance) !== null && _h !== void 0 ? _h : total.bonuses.balance,
            },
        };
    }, {
        time: {
            carry: (firstTimeBalance === null || firstTimeBalance === void 0 ? void 0 : firstTimeBalance.carry) || 0,
            work: 0,
            absences: 0,
            adjustments: 0,
            actual: 0,
            nominal: 0,
            difference: 0,
            balance: (firstTimeBalance === null || firstTimeBalance === void 0 ? void 0 : firstTimeBalance.balance) || 0,
            reset: firstTimeBalance === null || firstTimeBalance === void 0 ? void 0 : firstTimeBalance.reset,
        },
        vacation: {
            carry: (firstResult === null || firstResult === void 0 ? void 0 : firstResult.vacationBalance.carry) || 0,
            adjustments: 0,
            taken: 0,
            actual: 0,
            nominal: 0,
            difference: 0,
            balance: (firstResult === null || firstResult === void 0 ? void 0 : firstResult.vacationBalance.balance) || 0,
            reset: firstResult === null || firstResult === void 0 ? void 0 : firstResult.vacationBalance.reset,
        },
        bonuses: {
            carry: firstResult === null || firstResult === void 0 ? void 0 : firstResult.bonusesBalance.carry,
            taxed: 0,
            untaxed: 0,
            actual: 0,
            balance: firstResult === null || firstResult === void 0 ? void 0 : firstResult.bonusesBalance.balance,
            reset: firstResult === null || firstResult === void 0 ? void 0 : firstResult.bonusesBalance.reset,
        },
    });
    return roundValues ? roundBalances(balances) : balances;
}
function aggregateTimeBalances(employee, { from, to }, results, roundValues = true, projected = false) {
    const firstResult = results[0];
    const lastResult = results[results.length - 1];
    const today = (0, util_1.toDateString)(new Date());
    const firstBalance = (projected && (firstResult === null || firstResult === void 0 ? void 0 : firstResult.date) >= today && (firstResult === null || firstResult === void 0 ? void 0 : firstResult.timeBalancePlanned)) || (firstResult === null || firstResult === void 0 ? void 0 : firstResult.timeBalance);
    const lastBalance = (projected && (lastResult === null || lastResult === void 0 ? void 0 : lastResult.date) >= today && (lastResult === null || lastResult === void 0 ? void 0 : lastResult.timeBalancePlanned)) || (lastResult === null || lastResult === void 0 ? void 0 : lastResult.timeBalance);
    const balance = results.reduce((total, result) => {
        const balance = (projected && result.date >= today && result.timeBalancePlanned) || result.timeBalance;
        return {
            ...addTimeBalances(total, balance),
            employeeId: employee.id,
            from,
            to,
            reset: total.reset,
            carry: total.carry,
            balance: total.balance,
        };
    }, {
        ...makeEmptyTimeBalance({ employeeId: employee.id, from, to }),
        reset: firstBalance === null || firstBalance === void 0 ? void 0 : firstBalance.reset,
        carry: (firstBalance === null || firstBalance === void 0 ? void 0 : firstBalance.carry) || 0,
        balance: (lastBalance === null || lastBalance === void 0 ? void 0 : lastBalance.balance) || 0,
    });
    return roundValues ? roundTimeBalance(balance) : balance;
}
function aggregateVacationBalances(employee, { from, to }, results, roundValues = true) {
    const firstResult = results[0];
    const lastResult = results[results.length - 1];
    const balance = results.reduce((total, result) => {
        return {
            ...addVacationBalances(total, result.vacationBalance),
            employeeId: employee.id,
            from,
            to,
            reset: total.reset,
            carry: total.carry,
            balance: total.balance,
        };
    }, {
        ...makeEmptyVacationBalance({ employeeId: employee.id, from, to }),
        reset: firstResult === null || firstResult === void 0 ? void 0 : firstResult.vacationBalance.reset,
        carry: (firstResult === null || firstResult === void 0 ? void 0 : firstResult.vacationBalance.carry) || 0,
        balance: (lastResult === null || lastResult === void 0 ? void 0 : lastResult.vacationBalance.balance) || 0,
    });
    return roundValues ? roundVacationBalance(balance) : balance;
}
function aggregateBonusesBalances(employee, { from, to }, results, roundValues = true) {
    const firstResult = results[0];
    const lastResult = results[results.length - 1];
    const balance = results.reduce((total, result) => {
        return {
            ...addBonusesBalances(total, result.bonusesBalance),
            employeeId: employee.id,
            from,
            to,
            reset: total.reset,
            carry: total.carry,
            balance: total.balance,
        };
    }, {
        ...makeEmptyBonusesBalance({ employeeId: employee.id, from, to }),
        reset: firstResult === null || firstResult === void 0 ? void 0 : firstResult.bonusesBalance.reset,
        carry: (firstResult === null || firstResult === void 0 ? void 0 : firstResult.bonusesBalance.carry) || 0,
        balance: (lastResult === null || lastResult === void 0 ? void 0 : lastResult.bonusesBalance.balance) || 0,
    });
    return roundValues ? roundBonusesBalance(balance) : balance;
}
function getChunks({ from, to }, resets) {
    const chunks = [];
    let chunkFrom = from;
    for (const reset of resets) {
        chunks.push({
            from: chunkFrom,
            to: reset.date,
        });
        chunkFrom = reset.date;
    }
    chunks.push({
        from: chunkFrom,
        to,
    });
    return chunks;
}
function timeBalanceFromDailyResults(employee, range, results, roundValues = true, projected = false) {
    const balance = aggregateTimeBalances(employee, range, results, roundValues, projected);
    const resets = results.filter((res, i) => i !== 0 && typeof res.timeBalance.reset !== "undefined");
    if (resets.length) {
        const chunks = getChunks(range, resets);
        balance.subBalances = [];
        for (const subRange of chunks) {
            balance.subBalances.push(aggregateTimeBalances(employee, subRange, results.filter((res) => res.date >= subRange.from && res.date < subRange.to), true, projected));
        }
    }
    return balance;
}
function vacationBalanceFromDailyResults(employee, range, results, roundValues = true) {
    const balance = aggregateVacationBalances(employee, range, results, roundValues);
    const resets = results.filter((res, i) => i !== 0 && typeof res.vacationBalance.reset !== "undefined");
    if (resets.length) {
        const chunks = getChunks(range, resets);
        balance.subBalances = [];
        for (const subRange of chunks) {
            balance.subBalances.push(aggregateVacationBalances(employee, subRange, results.filter((res) => res.date >= subRange.from && res.date < subRange.to), true));
        }
    }
    return balance;
}
function bonusesBalanceFromDailyResults(employee, range, results, roundValues = true) {
    const balance = aggregateBonusesBalances(employee, range, results, roundValues);
    const resets = results.filter((res, i) => i !== 0 && typeof res.bonusesBalance.reset !== "undefined");
    if (resets.length) {
        const chunks = getChunks(range, resets);
        balance.subBalances = [];
        for (const subRange of chunks) {
            balance.subBalances.push(aggregateBonusesBalances(employee, subRange, results.filter((res) => res.date >= subRange.from && res.date < subRange.to), true));
        }
    }
    return balance;
}
function getResultBreakDown(company, timeEntries) {
    timeEntries = timeEntries.filter((e) => e.type !== model_1.TimeEntryType.VacationAdjustment && Boolean(e.result));
    const breakdown = {
        items: [],
        total: getTotalResults(timeEntries.filter((e) => Boolean(e.result)).map((entry) => entry.result)),
    };
    const items = new Map();
    for (const { type, positionId, result, comment } of timeEntries) {
        if (!result) {
            continue;
        }
        const key = [model_1.TimeEntryType.HourAdjustment, model_1.TimeEntryType.VacationAdjustment].includes(type)
            ? `${type}_${positionId}_${comment}`
            : `${type}_${positionId}`;
        const existing = items.get(key);
        if (existing) {
            existing.result = addTimeResults(existing.result, result);
        }
        else {
            const workArea = (positionId && company.getPosition(positionId)) || null;
            items.set(key, {
                type,
                result,
                workArea,
                comment: [model_1.TimeEntryType.HourAdjustment, model_1.TimeEntryType.VacationAdjustment].includes(type)
                    ? comment
                    : undefined,
            });
        }
    }
    breakdown.items = [...items.values()];
    return breakdown;
}
function getAvailableActions(timeEntry, settings) {
    const startString = timeEntry.startFinal || timeEntry.startPlanned || new Date();
    const startTime = new Date(startString).getTime();
    const canStart = startTime - settings.allowEarlyStart * exports.hour < Date.now();
    const isUnlocked = Date.now() < startTime + settings.lockAfter * exports.hour;
    const shiftReady = canStart && isUnlocked;
    // Can't do anything if shift is not ready
    if (!shiftReady)
        return [];
    // If paused, can end the break or the shift
    if (timeEntry.status === "paused") {
        return ["endBreak", "endShift"];
    }
    // If ongoing, can end the shift or start a break if allowed
    if (timeEntry.status === "ongoing") {
        if (settings.manualBreaksAllowed) {
            return ["startBreak", "endShift"];
        }
        return ["endShift"];
    }
    // If scheduled, can start the shift
    if (timeEntry.status === "scheduled") {
        return ["startShift"];
    }
    // Default (e.g completed), can't do anything
    return [];
}
function getVacationEntitlement(balance) {
    var _a, _b;
    if (!balance) {
        return {
            available: 0,
            taken: 0,
            remaining: 0,
        };
    }
    const lastBalance = ((_a = balance.subBalances) === null || _a === void 0 ? void 0 : _a.length) ? balance.subBalances[balance.subBalances.length - 1] : balance;
    const available = (0, openapi_1.add)((_b = lastBalance.reset) !== null && _b !== void 0 ? _b : lastBalance.carry, lastBalance.nominal);
    const taken = lastBalance.actual;
    return {
        available,
        taken,
        remaining: (0, openapi_1.subtract)(available, taken),
    };
}
function getCommonWorkDays(dailyResults) {
    const daysPerWeekDay = [0, 0, 0, 0, 0, 0, 0];
    const daysPerWeek = new Map();
    for (const dailyResult of dailyResults) {
        const isWorkOrAbsenceDay = dailyResult.results.work.base.duration > 0 || dailyResult.results.absences.base.duration > 0;
        const weekDay = new Date(dailyResult.date).getDay();
        if (isWorkOrAbsenceDay) {
            daysPerWeekDay[weekDay]++;
            const week = `${(0, util_1.parseDateString)(dailyResult.date).getFullYear()},${(0, util_1.getWeekNumber)(dailyResult.date)}`;
            daysPerWeek.set(week, (daysPerWeek.get(week) || 0) + 1);
        }
    }
    const daysPerWeekArr = Array.from(daysPerWeek.values());
    const totaldays = daysPerWeekArr.reduce((a, b) => a + b, 0);
    const weeksWorked = daysPerWeekArr.filter((val) => val > 0).length;
    const averageDaysPerWeek = Math.round(totaldays / weeksWorked);
    const commonWorkDays = daysPerWeekDay
        .map((count, i) => [count, i])
        .sort(([a], [b]) => b - a)
        .slice(0, averageDaysPerWeek)
        .map(([, i]) => i);
    return commonWorkDays;
}
function calculateBonusDuration(date, bonusTypeMode, applicableDuration, baseDuration) {
    if (bonusTypeMode === model_1.BonusTypeMode.Daily) {
        // always use the 13-week average for daily bonuses
        return applicableDuration;
    }
    else if (bonusTypeMode === model_1.BonusTypeMode.WeekDays && date.getDay() !== 0) {
        // for week day bonuses (except sundays) use the 13-week average
        return applicableDuration;
    }
    // use base duration for sundays, holidays and single dates (like 24.12.)
    return baseDuration;
}
//# sourceMappingURL=time.js.map